<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="活动搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请搜索活动名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 12px;" @click="erwmOpenBtn">小程序码</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加活动</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityName"
            label="活动名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="limitType"
            label="限领类型">
            <template slot-scope="scope">
              <span v-if="scope.row.limitType === 1">每天限领</span>
              <span v-else-if="scope.row.limitType === 2">总限领</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="limitNum"
            label="限领次数">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
              <el-button @click="prizeManageBtn(scope.row.id)" type="text" size="small">奖品管理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 小程序码弹窗 -->
    <el-dialog
      title="小程序码"
      :visible.sync="erwmShow"
      width="960px">
      <div class="flex-justify-center">
        <el-image
              style="width:256px;height: 256px;"
              :src="erwmImg"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryLotteryActivityConfigPageList, removeLotteryActivityConfigById, generateWechatUnlimitedQrCode } from '@/api/prizeDraw'
export default {
  name: 'PrizeDraw',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 小程序码弹窗
      erwmShow:false,
      erwmImg:''
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryLotteryActivityConfigPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 小程序码弹窗-打开操作
    erwmOpenBtn () {
      var that = this;
      generateWechatUnlimitedQrCode({}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            var data = res.data;
            that.erwmImg = data.fileUrl;
            that.erwmShow = true;
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/prize_draw_add', query: {dataId: infoId}})
    },
    /* 奖品管理 */
    prizeManageBtn (infoId) {
      this.$router.push({path: '/prize_draw_manage', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeLotteryActivityConfigById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/prizeDraw/PrizeDraw.vue